import React from "react";
import Table from "react-bootstrap/Table";
import { Card, CardHeader, Row, Col, CardBody } from "shards-react";
import { Link } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import FunctionDataService from "../../services/function.service";
import { FcPlus } from "react-icons/fc";
import moment from "moment";
import "react-toastify/dist/ReactToastify.css";
import ReactTooltip from "react-tooltip";
import { actions as AppActions } from "../../_stores/app.store";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import authStore from "../../_stores/auth.store";

const perPage = 10;

class ViewFunctionSuperAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      functionList: [],
      functionList_paged: [],
    };
    this.aggridRef = React.createRef();
  }

  componentDidMount() {
    this.retrieveFunctions();
  }

  componentDidUpdate(prevProps) {}

  retrieveFunctions() {
    AppActions.setLoading(true);
    FunctionDataService.getAll().then((response) => {
      AppActions.setLoading(false);
      this.setState({
        functionList: response.data.data,
      });
    });
  }

  deleteFunction(id) {
    AppActions.setLoading(true);
    FunctionDataService.delete(id).then((response) => {
      this.retrieveFunctions();
      this.props.notify("success", "Function Deleted");
    })
    .catch((error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      this.setState({
        message: message,
      });
      this.props.notify("error", message);
      AppActions.setLoading(false);
    });
  }

  onPageSizeChanged(e) {
    let value = e.target.value;
    this.aggridRef.current.api.paginationSetPageSize(Number(value));
  };


  render() {
    const { functionList, functionList_paged } = this.state;
    const columnDefs = [
      {headerName: "Transaction Function Name", field: "functionName", filter: true, sortable:true, unSortIcon:true },
      {headerName: "Stored Procedure Name", field: "procedureName",filter: true, sortable:true, unSortIcon:true},
      {headerName: "updatedAt", field: "updatedAt",filter: true,  sortable:true, width:"160",
          cellRendererFramework: (data) => {
            return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
          } 
      },
      {headerName: "action", field:"id", 
          cellRendererFramework: (data) => {
              return <>
                        <Link title="Details" className="text-primary mr-2" to={"/function/"+data.value+"/details"}><TiEyeOutline  size="20" /></Link>
                        <Link title="Edit" className="text-success mr-2" to={"/function/"+data.value+"/edit"}><TiEdit  size="20" /></Link>
                        {authStore.getState().auth_reducer.user.role === "superadmin" && (
                          <span className="text-danger cursor-pointer" title="delete" onClick={() => this.deleteFunction(data.value)}><TiDeleteOutline size="20" /></span>
                        )}
                     </>
         }
      }
    ]

    return (
      <>
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardHeader className="border-bottom">
                <h6 className="m-0">
                  Functions List
                  <Link className="btn btn-primary ml-4" to={`/create-function-superadmin/${this.props.projectId}`}>
                    <FcPlus /> Create New Transaction Function
                  </Link>
                </h6>
              </CardHeader>
              <CardBody className="p-0 pb-3">
              <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                  <div className="example-header">
                    Page Size: &nbsp;
                    <select onChange={this.onPageSizeChanged} id="page-size">
                      <option value="10" selected={true}>
                        10
                      </option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </div>
                  <AgGridReact
                      ref={this.aggridRef}
                      pagination={true}
                      rowHeight={50}
                      paginationPageSize={perPage}
                      columnDefs={columnDefs}
                      rowData={functionList}
                  >
                  </AgGridReact>
                </div>

                <div className="table-responsive variant-01">
                  <Table className="table mb-0 border-bottom" size="md">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col" className="border-0">
                          Transaction Function Name
                        </th>
                        <th scope="col" className="border-0">
                          Stored Procedure Name
                        </th>
                        <th scope="col" className="border-0">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {functionList_paged && functionList_paged.length
                        ? functionList_paged.map((item, index) => {
                            return (
                              <tr key={index + 1}>
                                <td>{item.functionName}</td>
                                <td> {item.procedureName}</td>
                                <td>
                                  <Link
                                    className="text-primary"
                                    data-tip
                                    data-for="detailTip"
                                    to={"/function/" + item.id + "/details"}
                                  >
                                    <TiEyeOutline />
                                  </Link>
                                  <ReactTooltip id="detailTip" place="top" effect="solid">
                                    Detail
                                  </ReactTooltip>
                                  <Link
                                    className="text-success"
                                    data-tip
                                    data-for="editTip"
                                    to={"/function/" + item.id + "/edit"}
                                  >
                                    <TiEdit />
                                  </Link>
                                  <ReactTooltip id="editTip" place="top" effect="solid">
                                    Edit
                                  </ReactTooltip>
                                </td>
                              </tr>
                            );
                          })
                        : null}
                    </tbody>
                  </Table>
                </div>
               
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default ViewFunctionSuperAdmin;
